import { defineMessages } from 'react-intl';

import ThumbUpIcon from '../../static/icons/controls-thumb-up-filled.svg';
import Dot from '../../static/icons/dot.svg';
import ChevronBack from '../../static/icons/ic_chevron_back.svg';
import ChevronForward from '../../static/icons/ic_chevron_forward.svg';
import DeviceIcon from '../../static/icons/landing_ball_devices.svg';
import LogoPIcon from '../../static/icons/landing_logo_p.svg';
import LandingCirclesIcon from '../../static/icons/landingpage_circles.svg';
import LogoPandoraIcon from '../../static/icons/logo/ic_logo_pandora_r.svg';
import MOBILE_DEVICE from '../../static/images/device_plus_premium.png';
import MOBILE_GET_IT_FROM_AMAZON from '../../static/images/landing_get_it_from_amazon.png';
import MOBILE_GET_IT_FROM_APPLE from '../../static/images/landing_get_it_from_apple.png';
import MOBILE_GET_IT_FROM_GOOGLE from '../../static/images/landing_get_it_from_google.png';
import MOBILE_GET_IT_FROM_MICROSOFT from '../../static/images/landing_get_it_from_microsoft.png';
import MGP_GUITAR from '../../static/images/landing_mgp_guitar.jpg';
import MGP_HEADPHONES from '../../static/images/landing_mgp_headphones.jpg';
import MGP_PANDORA from '../../static/images/landing_mgp_pandora.jpg';

export const PurchaseLinks = Object.freeze({
  ITUNES: 'https://itunes.apple.com/us/app/pandora-radio/id284035177',
  GOOGLE: 'https://play.google.com/store/apps/details?id=com.pandora.android&hl=en',
  MICROSOFT: 'https://www.microsoft.com/en-us/store/apps/pandora/9wzdncrfj46v',
  AMAZON: 'http://www.amazon.com/gp/mas/dl/android?p=com.pandora.android',
  GOOGLE_DEEPLINK: 'https://play.google.com/store/apps/details?id=com.pandora.android&referrer=',
} as const);

export const Icons = Object.freeze({
  LogoPandoraIcon,
  LogoPIcon,
  ThumbUpIcon,
  LandingCirclesIcon,
  DeviceIcon,
  Dot,
  ChevronBack,
  ChevronForward,
} as const);

export const Images = Object.freeze({
  MGP_GUITAR,
  MGP_HEADPHONES,
  MGP_PANDORA,
  MOBILE_DEVICE,
  MOBILE_GET_IT_FROM_APPLE,
  MOBILE_GET_IT_FROM_GOOGLE,
  MOBILE_GET_IT_FROM_MICROSOFT,
  MOBILE_GET_IT_FROM_AMAZON,
} as const);

export const SectionNames = Object.freeze({
  PLANS: 'plans',
  GENOME: 'genome',
  MOBILE: 'mobile',
} as const);

export const Signup = Object.freeze({
  TRACKS_ITEMS_MAX: 8,
  TRACKS_ITEMS_CENTERED_IN_FIRST_ROW: 4,
} as const);

export const StatsOnboardingActions = Object.freeze({
  CLICK_VIEW_PLANS: 'view_plans_clicked_from_landing_page',
  CLICK_SIGN_UP_LANDING: 'sign_up_clicked_from_landing_page',
  CLICK_SIGN_UP_LANDING_FOOTER: 'sign_up_clicked_from_landing_page_footer',
  CLICK_LOGIN_LANDING: 'log_in_clicked_from_landing_page',
  CLICK_LOGIN_LANDING_FOOTER: 'log_in_clicked_from_landing_page_footer',
  CLICK_IOS_STORE: 'ios_store_clicked_from_landing_page',
  CLICK_GOOGLE_STORE: 'google_store_clicked_from_landing_page',
  CLICK_TO_START_LISTENING: 'click_to_start_listening',
  HELP_CLICKED: 'help_clicked_from_landing_page',
  LANDING_PAGE_SHOWN: 'landing_page_shown',
  MOBILE_WELCOME_LANDING_PAGE_SHOWN: 'mobile_welcome_landing_page_shown',
  FORGOT_PW: 'forgot_pw',
  PWD_RESET: 'pwd_reset',
  PWD_RESET_EXP: 'pwd_reset_exp',
  PREMIUM_FEATURES: 'pandora_premium_features_page',
  FORGOT_PWD_CLICK: 'forgot_pwd_clicked',
  MENU_CLICK: 'menu_click',
  MENU_SIGNUP: 'menu_signup',
  MENU_LOGIN: 'menu_login',
  MENU_HELP: 'menu_help',
  LOGIN_ATTEMPT: 'login_attempt',
  LOGIN_SUCCESS: 'login_success',
  EMAIL_INPUT: 'email_input',
  PWD_INPUT: 'pwd_input',
  NEW_PWD_INPUT: 'new_pwd_input',
  CONFIRM_PWD_INPUT: 'confirm_pwd_input',
  USER_INPUT: 'user_input',
  CAROUSEL_APP: 'carousel_app',
  CANCEL_CLICKED: 'cancel_clicked',
  RESET_PW_ATTEMPT: 'reset_pw_attempt',
  CREATE_NEW_PASSWORD_ATTEMPT: 'new_pw_attempt',
  RETURN_TO_LOGIN_CLICKED: 'return_to_login_clicked',
  CHECK_EMAIL_SUCCESS: 'check_your_email_success',
  STANDARD: 'standard',
} as const);

export const messages = defineMessages({
  searchPlaceHolderPremiumAccess: {
    id: 'searchPlaceHolderPremiumAccess',
    defaultMessage: 'Search for artists, songs and stations.',
  },
  searchPlaceHolder: {
    id: 'searchPlaceHolder',
    defaultMessage: 'Enter an artist, song, or genre to create a station.',
  },
  searchTitle: {
    id: 'onboarding.searchTitle',
    defaultMessage: 'Start listening for free.',
  },
  mobileSplashTitle: {
    id: 'onboarding.mobileSplashTitle',
    defaultMessage:
      'Explore the new Pandora, from the free stations you love to ad\u2011free search\u00A0and\u00A0play.',
  },
  viewPlans: {
    id: 'onboarding.viewPlans',
    defaultMessage: 'View Plans',
  },
  searchExplanation: {
    id: 'onboarding.searchExplanation',
    defaultMessage: 'Every Pandora station evolves with your tastes. Sit back and enjoy.',
  },
  genomeTitle: {
    id: 'onboarding.genomeTitle',
    defaultMessage: "A hand-curated listening experience {newline} that's uniquely yours.",
  },
  musicGenomeProject: {
    id: 'onboarding.musicGenomeProject',
    defaultMessage: 'Music Genome Project',
  },
  genomeTile1TextOld: {
    id: 'onboarding.genomeTile1Text',
    defaultMessage:
      "The {musicGenomeProject} powers Pandora. It's the most comprehensive analysis of music ever undertaken.",
  },
  genomeTile2TextOld: {
    id: 'onboarding.genomeTile2Text',
    defaultMessage:
      'Our team of trained musicologists has been listening to music across all genres and decades, one song at a time, studying and collecting musical details on every track - 450 musical attributes altogether.',
  },
  genomeTile3TextOld: {
    id: 'onboarding.genomeTile3Text',
    defaultMessage:
      'The {musicGenomeProject} enables Pandora to respond to your tastes and tailor each station to you.',
  },
  genomeTile1Header: {
    id: 'onboarding.genomeTile1Header',
    defaultMessage: 'The most extensive analysis of music ever undertaken.',
  },
  genomeTile2Header: {
    id: 'onboarding.genomeTile2Header',
    defaultMessage: 'Your Thumbs take it to the next level.',
  },
  genomeTile3Header: {
    id: 'onboarding.genomeTile3Header',
    defaultMessage: 'Explore the new Pandora!',
  },
  genomeTile1Text: {
    id: 'onboarding.genomeTile1Text',
    defaultMessage:
      'Pandora started with the {musicGenomeProject}, where our music experts analyzed every song on Pandora across genres and decades for nearly 500 musical traits.',
  },
  genomeTile2Text: {
    id: 'onboarding.genomeTile2Text',
    defaultMessage:
      "Pandora is powered by this analysis in combination with your Thumbs Up and Thumbs Down. That's how we personalize what plays next, just for you.",
  },
  genomeTile3Text: {
    id: 'onboarding.genomeTile3Text',
    defaultMessage:
      "Go beyond stations and find the music, comedy and podcasts you love. Play any song from Pandora's library, magically make playlists, go offline and more.",
  },
  mobileSectionTitle: {
    id: 'onboarding.mobileSectionTitle',
    defaultMessage: 'Listen anytime, anywhere.',
  },
  mobileSectionSubTitle1: {
    id: 'onboarding.mobileSectionSubTitle1',
    defaultMessage: 'Take your music with you wherever you go.',
  },
  mobileSectionSubTitleOld2: {
    id: 'onboarding.mobileSectionSubTitle2',
    defaultMessage:
      'Create an account and listen to Pandora on your mobile devices, desktop, TV, or in the car.',
  },
  mobileSectionSubTitle2: {
    id: 'onboarding.mobileSectionSubTitle2',
    defaultMessage:
      'Listen to Pandora on mobile devices, desktop, TV, Apple Watch, using voice assistants, or in the car.',
  },
  signUpSectionTitle: {
    id: 'onboarding.signUpSectionTitle',
    defaultMessage: 'Choose how you want to listen.',
  },
  myStationsEmptyHeaderTitlePremiumAccess: {
    id: 'myStationsEmptyHeaderTitlePremiumAccess',
    defaultMessage: 'Start Listening.',
  },
  myStationsEmptyHeaderTitle: {
    id: 'myStationsEmptyHeaderTitle',
    defaultMessage: 'Create your first station.',
  },
  offlineStationsText: {
    id: 'offlineStationsText',
    defaultMessage: 'Offline stations',
  },
  createStationsAndPlaylistsText: {
    id: 'createStationsAndPlaylistsText',
    defaultMessage: 'Create stations and playlists',
  },
  downloadAnythingText: {
    id: 'downloadAnythingText',
    defaultMessage: 'Download anything you want',
  },
  getTheAppText: {
    id: 'getTheAppText',
    defaultMessage: 'Get the App',
  },
  listenInTheAppText: {
    id: 'listenInTheAppText',
    defaultMessage: 'Listen in App',
  },
  signUpNowText: {
    id: 'signUpNowText',
    defaultMessage: 'Sign Up Now',
  },
  signUpToStartText: {
    id: 'signUpToStartText',
    defaultMessage: 'Sign up to start listening for free.',
  },
} as const);
